import fp from "lodash/fp";

import { merchantFinancialService } from "services";

import { financialConstants } from "./financial.constants";


export const merchantFinancialActions = {
	addFinancial,
	editFinancial,
	deleteFinancial,
	addFinancials,

	addBankBalance,
	editBankBalance,
	deleteBankBalance,
	addBankBalances,
};

function addFinancial(financial) {
	return {
		type: financialConstants.MERCHANT_FINANCIALS_ADD_LOCAL_FINANCIAL,
		financial,
	};
}
function editFinancial(index, financial) {
	return {
		type: financialConstants.MERCHANT_FINANCIALS_EDIT_LOCAL_FINANCIAL,
		index,
		financial,
	};
}
function deleteFinancial(index) {
	return {
		type: financialConstants.MERCHANT_FINANCIALS_DELETE_LOCAL_FINANCIAL,
		index,
	};
}
function addFinancials(merchantId) {
	return (dispatch, getState) => {
		const financials = fp.flow(
			fp.get("merchantFinancials.financials"),
			fp.map(x => ({ ...x, id: undefined })),
		)(getState());

		if (financials && financials.length) {
			dispatch(request());

			return merchantFinancialService
				.addFinancials(merchantId, financials)
				.then(
					result => {
						dispatch(success(result));
						return Promise.resolve();
					},
					error => {
						dispatch(failure(error));
						return Promise.reject(error);
					},
				);
		}
	};

	function request() {
		return {
			type: financialConstants.MERCHANT_FINANCIALS_SAVE_FINANCIALS_REQUEST,
		};
	}
	function success() {
		return {
			type: financialConstants.MERCHANT_FINANCIALS_SAVE_FINANCIALS_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: financialConstants.MERCHANT_FINANCIALS_SAVE_FINANCIALS_ERROR,
			error,
		};
	}
}

function addBankBalance(bankBalance) {
	return {
		type: financialConstants.MERCHANT_FINANCIALS_ADD_LOCAL_BANK_BALANCE,
		bankBalance,
	};
}
function editBankBalance(index, bankBalance) {
	return {
		type: financialConstants.MERCHANT_FINANCIALS_EDIT_LOCAL_BANK_BALANCE,
		index,
		bankBalance,
	};
}
function deleteBankBalance(index) {
	return {
		type: financialConstants.MERCHANT_FINANCIALS_DELETE_LOCAL_BANK_BALANCE,
		index,
	};
}
function addBankBalances(merchantId) {
	return (dispatch, getState) => {
		const bankBalances = fp.flow(
			fp.get("merchantFinancials.bankBalances"),
			fp.map(x => ({ ...x, id: undefined })),
		)(getState());

		if (bankBalances && bankBalances.length) {
			dispatch(request());

			return merchantFinancialService
				.addBankBalances(merchantId, bankBalances)
				.then(
					result => {
						dispatch(success(result));
						return Promise.resolve();
					},
					error => {
						dispatch(failure(error));
						return Promise.reject(error);
					},
				);
		}
	};

	function request() {
		return {
			type: financialConstants.MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_REQUEST,
		};
	}
	function success() {
		return {
			type: financialConstants.MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_SUCCESS,
		};
	}
	function failure(error) {
		return {
			type: financialConstants.MERCHANT_FINANCIALS_SAVE_BANK_BALANCES_ERROR,
			error,
		};
	}
}
